/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  IAssured,
  IEAssured,
  IError,
  IValues,
  IshowErrorAssuredDefault,
  IshowErrorValuesDefault,
  ModalDataDTO,
} from '../../../types/interface/Assurance/AssuranceVoyage/souscription';

/* eslint-disable @typescript-eslint/no-unsafe-function-type */
export const showErrorAssuredDefault: IshowErrorAssuredDefault = {
  nom: false,
  prenom: false,
  dateNaissance: false,
  lieuNaissance: false,
  email: false,
  telephone: false,
  countryCode: false,
  numPasseport: false,
  datePasseport: false,
  passport_file: false,
};

export const showErrorValuesDefault: IshowErrorValuesDefault = {
  agence: false,
  montant: false,
  category: false,
  destination: false,
  dateDebut: false,
  dateFin: false,
  assure: [],
};

export const showErrorAssuredSubmit = {
  nom: true,
  prenom: true,
  dateNaissance: true,
  lieuNaissance: true,
  email: true,
  telephone: true,
  countryCode: true,
  numPasseport: true,
  datePasseport: true,
  passport_file: true,
};

export const showErrorValuesSubmit = {
  agence: true,
  montant: true,
  category: false,
  destination: false,
  dateDebut: false,
  dateFin: false,
  assure: [],
};

export const defaultErrorAssured: IEAssured = {
  nom: '',
  prenom: '',
  dateNaissance: '',
  lieuNaissance: '',
  email: '',
  telephone: '',
  countryCode: '',
  numPasseport: '',
  datePasseport: '',
  passport_file: '',
};

export const defaultErrorValues: IError = {
  agence: '',
  montant: '',
  category: '',
  destination: '',
  dateDebut: '',
  dateFin: '',
  userIsAssured: false,
  assure: [],
};

export const defaultAssured: IAssured = {
  id: '',
  nom: '',
  prenom: '',
  dateNaissance: undefined,
  lieuNaissance: '',
  email: '',
  telephone: '',
  countryCode: 'FR',
  numPasseport: '',
  datePasseport: '',
  passport_file: undefined,
};

export const defaultValues: IValues = {
  agence: '',
  montant: '',
  category: '',
  destination: '',
  dateDebut: '',
  dateFin: '',
  userIsAssured: false,
  assure: [],
  quoteCode: '',
};

export const dataConfig = {
  ageGap: {
    enfant: {min: 0, max: 19},
    adult: {min: 19, max: 66},
    senior: {min: 66, max: 1000},
  },
};

export const modalDatasModified = {
  title: 'Information',
  content: `En ajustant le nombre d'assurés, le devis que vous avez reçu ne sera plus applicable, et cela entraînera une modification du montant indiqué dans la partie récapitulative.`,
  btn1: 'OK',
  btn2: 'Annuler',
};

export const initModalData: ModalDataDTO = {
  status: false,
  title: '',
  content: '',
  btn1: '',
  btn2: '',
  handleBtn1: () => {},
  handleBtn2: () => {},
};

export const listAssured: Array<{id: string; menu: 'sante' | 'renseignement'}> =
  [];

export const listRenseignement: Array<string> = [
  'nom',
  'prenom',
  'dateNaissance',
  'lieuNaissance',
  'email',
  'telephone',
  'numPasseport',
  'lieuPaseport',
];

export const TitleLabels = {
  contractant: {
    nomPrenomBeneficiaire: 'Nom et prénom(s) du Bénéficiaire',
    dateNaissanceBeneficiaire: 'Date de naissance du Bénéficiaire ',
    telephoneBeneficiaire: 'Téléphone du Bénéficiaire',
    emailBeneficiaire: 'Email Bénéficiaire',
    nombreAnimauxDomestique: "Nombre d'animaux domestiques",
    adresse: 'Adresse ',
    agence: 'Agence ',
    montant: 'Prime TTC à payer (en Ariary)',
    dateEffet: "Date d'effet",
  },
};
